
import { ISlot, Signal, SlotList } from "signals.js";

/**
 *    GoodgameSignal
 *
 *    @author Alexander
 */

export class GoodgameSignal extends Signal {
    constructor(...parameters) {
        // @ https://github.com/GoodgameStudios/SignalsJS/blob/master/src/org/osflash/signals/OnceSignal.ts
        super(parameters);
    }

    /**
     * checks if method ist registered
     * @param method:Function
     * @return true, if method is registered, false, if not
     *
     */
    public hasListener(method: Function): boolean {
        if (this.numListeners > 0 && this.slots.contains(method)) {
            return true;
        }

        return false;
    }

    /**
     * puts slot to the first position in handler list
     * @param slot:ISlot
     * @return
     *
     */
    public prependSlot(slot: ISlot): SlotList {
        return this.slots.prepend(slot);
    }

    /**
     * puts slot to the last position in handler list
     * @param slot:ISlot
     * @return
     *
     */
    public appendSlot(slot: ISlot): SlotList {
        return this.slots.append(slot);
    }

    public get isDisposed(): boolean {
        let dispose: boolean = this.numListeners == 0;
        return dispose;
    }

    public toString(): string {
        // TODO: @HTML5
        return ""//getQualifiedClassName(this).match("[^:]*$")[0];
    }

    /**
     * iterate through all GoodgameSignals in an Object
     * call isDisposed method
     * attention, this methid is only for debuging
     * @param objectToCheck
     *
     */
    public static checkSignals(objectToCheck: Object): void {
        //			//TODO Enable if needed fior debuging
        //			for each (let variable:XML in describeType( objectToCheck ).variable)
        //			{
        //				let property:String = variable.@name.toString();
        //
        //				if (objectToCheck[ property ] is GoodgameSignal)
        //				{
        //					let ggSignal:GoodgameSignal = objectToCheck[ property ] as GoodgameSignal;
        //
        //					if (!ggSignal.isDisposed)
        //					{
        //						error( "NOT_DISPOSED " + property + " listeners:" + ggSignal.listeners.length )
        //					}
        //				}
        //			}
    }
}
